import { render, staticRenderFns } from "./ChatUnsupportedFilesModal.vue?vue&type=template&id=c1b8bb24&scoped=true&"
import script from "./ChatUnsupportedFilesModal.vue?vue&type=script&lang=js&"
export * from "./ChatUnsupportedFilesModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatUnsupportedFilesModal.vue?vue&type=style&index=0&id=c1b8bb24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b8bb24",
  null
  
)

export default component.exports